import React from 'react';

import clsx from 'clsx';
import { ButtonBase, makeStyles, Theme, createStyles } from '@material-ui/core';

interface Props {
  images: { key: string; src: string }[];
  onOpen?: (index: number) => void;
}

// Pictures inside a bubble: one fills the width, more tile two to a row.
export const ChatMediaGrid: React.FC<Props> = ({ images, onOpen }) => {
  const classes = useStyles();
  const single = images.length === 1;

  return (
    <div className={clsx(classes.grid, { [classes.single]: single })}>
      {images.map((image, index) => (
        <ButtonBase
          key={image.key}
          className={clsx(classes.tile, {
            [classes.wide]: !single && images.length % 2 === 1 && index === images.length - 1,
          })}
          onClick={() => onOpen?.(index)}
          aria-label={`Open picture ${index + 1} of ${images.length}`}
        >
          <img src={image.src} alt="" className={classes.image} loading="lazy" />
        </ButtonBase>
      ))}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 2,
      width: 320,
      maxWidth: '100%',
      borderRadius: 14,
      overflow: 'hidden',
    },
    single: { gridTemplateColumns: '1fr' },
    tile: { display: 'block', aspectRatio: '1', backgroundColor: theme.palette.action.hover },
    wide: { gridColumn: '1 / -1', aspectRatio: '2' },
    image: { display: 'block', width: '100%', height: '100%', objectFit: 'cover' },
  })
);
